module.exports = __webpack_public_path__ + "img/5.d7c35f2d.webp";